import { render, staticRenderFns } from "./contratoDetalhes.vue?vue&type=template&id=5b25619c"
import script from "./contratoDetalhes.vue?vue&type=script&lang=js"
export * from "./contratoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./contratoDetalhes.vue?vue&type=style&index=0&id=5b25619c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports